module.exports = __webpack_public_path__ + "img/Digrab_Logo.e8943fa8.png";